<template>
  <div class="map_generate" style="position: relative;">
    <v-toolbar
      style="
      <!-- position: fixed; -->
      width: 100%;
      z-index: 2;
      "
    >
      <v-btn @click="backPage()" class="back_button">
        <v-icon color="blue darken-2"> mdi-arrow-left </v-icon>マップ一覧に戻る
      </v-btn>

      <v-spacer></v-spacer>

      <v-card-subtitle
        v-if="target_env == 'テスト環境'"
        style="font-size: 18px;
      color: green;
      padding: 6px 10px;
      margin-left: 20px;"
        >{{ target_env }}</v-card-subtitle
      >

      <v-card-subtitle
        v-else
        style="font-size: 18px;
      color: red;
      border: 1px solid;
      padding: 6px 10px;
      border-radius: 4px;
      margin-left: 20px;"
        >{{ target_env }}</v-card-subtitle
      >
    </v-toolbar>

    <v-row style="margin-top:10px !important;" dense>
      <v-overlay
        :absolute="absolute"
        :value="overlay"
        :opacity="opacity"
        style="z-index:100000"
      >
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </v-overlay>

      <v-col cols="4">
        <v-card class="ml-2 pa-2 mr-0">
          <!-- カテゴリ・アイコン設定ダイアログ -->

          <v-dialog v-model="icon_dialog" max-width="600" class="input_form">
            <v-card>
              <v-card-title>
                <div v-if="editIcon.type == 'category'">
                  カテゴリ追加({{ editIcon.type }})
                </div>
                <div v-else>アイコン追加</div>
              </v-card-title>
              <v-card-text>
                <span class="red--text"> (必須)</span>名前：
                <v-text-field v-model="editIcon.name"></v-text-field>
              </v-card-text>

              <v-card-text v-if="editIcon.type == 'icon'">
                <span v-if="editIcon.type == 'category'">(任意)</span
                ><span v-else class="red--text"> (必須)</span> 画像パス：
                /wp-content/~
                <img
                  :src="
                    imgLoad(editIcon.img) ||
                      'https://appmedia.jp/wp-content/uploads/9999/10/6e251bb8086c67330b8a7d878a4af1b9.png'
                  "
                  width="40"
                  height="40"
                  style="vertical-align: middle;border:1px solid #ddd;"
                />

                <v-text-field v-model="editIcon.img"></v-text-field>

                <div class="d-flex align-center">
                  <div>
                  <span class="gray--text"> (任意)</span><br />マッピングしたときの基準座標位置→<br />
                  基準にしたい番号を選択してください
                  <!-- <div>
                    <input type="text" v-model="editIcon.pos" style="width:120px;text-align: center;font-size:15px;border-bottom: 1px solid #333;"/>
                  </div> -->
                </div>

                  <div style="width=120px;margin-left:40px;">
                  <span class="position_check">
                    <div style="display:inline-block">
                      <img
                        :src="
                          imgLoad(editIcon.img) ||
                            'https://appmedia.jp/wp-content/uploads/9999/10/6e251bb8086c67330b8a7d878a4af1b9.png'
                        "
                        width="40"
                        height="40"
                        style="vertical-align: middle;border:1px solid #ddd;"
                      />
                    </div>

                    
                    <span :class="{'p1':1 , 'select': editIcon.pos == 1 }" @click="editIcon.pos = 1;">1</span>
                    <span :class="{'p2':1 , 'select': editIcon.pos == 2 }" @click="editIcon.pos = 2;">2</span>
                    <span :class="{'p3':1 , 'select': editIcon.pos == 3 }" @click="editIcon.pos = 3;">3</span>
                    <span :class="{'p4':1 , 'select': editIcon.pos == 4 }" @click="editIcon.pos = 4;">4</span>
                    <span :class="{'p5':1 , 'select': editIcon.pos == 5 }" @click="editIcon.pos = 5;">5</span>
                    <span :class="{'p6':1 , 'select': editIcon.pos == 6 }" @click="editIcon.pos = 6;">6</span>
                    <span :class="{'p7':1 , 'select': editIcon.pos == 7 }" @click="editIcon.pos = 7;">7</span>
                    <span :class="{'p8':1 , 'select': editIcon.pos == 8 }" @click="editIcon.pos = 8;">8</span>
                    <span :class="{'p9':1 , 'select': editIcon.pos == 9 }" @click="editIcon.pos = 9;">9</span>
                  </span>
                </div>

                </div>






              </v-card-text>
              <v-card-actions>
                <v-btn @click="deleteIcon"
                  ><v-icon color="red darken-2">
                    fa-trash
                  </v-icon></v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  v-if="editIcon.type == 'icon'"
                  @click="addIcon"
                  :disabled="btn_disable_flg"
                  >OK</v-btn
                >
                <v-btn
                  v-if="editIcon.type == 'category'"
                  @click="addCategory"
                  :disabled="btn_disable_flg"
                  >OK</v-btn
                >
                <v-btn @click="icon_dialog = false" :disabled="btn_disable_flg"
                  >閉じる</v-btn
                >
                <!-- <v-btn @click="confirm">確認</v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card-title class="custom_title"
            >ショートコード

            <v-spacer></v-spacer>

            <div class="pa-2" style="">
              <v-icon normal color="primary">fas fa-question</v-icon>

              <a
                target="_blank"
                class="pl-3"
                href="http://test.dev-appmedia.xyz/atelier-online/500973"
                >使い方(表示サンプル・オプション詳細)</a
              >
            </div>
          </v-card-title>
          <div
            v-if="saveData.id != -1"
            style="font-size:16px;padding-left:10px;"
          >
            [map_generate id={{ saveData.id }}]

            <div style="font-size:12px;color:#444">
              マップのショートコードは1記事に複数設定できますが、switch_tabs(タブ)で使う場合は、ショートコードの引数にtab_idの設定が必要になります。
              詳細は、
              <a
                target="_blank"
                href="http://test.dev-appmedia.xyz/atelier-online/500973"
                >使い方(表示サンプル・オプション詳細)</a
              >のページを参照してください。
            </div>
          </div>
          <div v-else>
            データ保存後に生成されます。
          </div>
          <v-card-title class="custom_title">保存名</v-card-title>
          <v-text-field
            v-model="saveData.name"
            hide-details="true"
            class="pt-2"
            label=" 例：【キャトバス】キャットタワーマップ1"
            outlined
          ></v-text-field>



          <v-card-title class="custom_title">マップ画像URL</v-card-title>
          <v-text-field
            v-model="main_img"
            hide-details="true"
            class="pt-0"
            outlined
          ></v-text-field>

          <!-- カテゴリソート -->
          <v-dialog
            v-model="category_sort_dialog"
            max-width="500"
            class="input_form"
          >
            <v-card class="pa-2">
              <v-card-title>カテゴリ並び替え</v-card-title>
              <draggable v-model="sort_category" :group="'category_item'">
                <div
                  v-for="item in sort_category"
                  :key="item.id"
                  class="item pa-1"
                  max-width="100"
                >
                  <v-card class="pa-2"
                    ><v-icon color="green darken-2" class="aaaa">
                      mdi-drag-vertical
                    </v-icon>
                    {{ item.name }}</v-card
                  >
                </div>
              </draggable>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="saveSortCategory">OK</v-btn>

                <v-btn @click="category_sort_dialog = false">キャンセル</v-btn>
                <!-- <v-btn @click="confirm">確認</v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card-title class="custom_title">アイコン設定</v-card-title>
          <p style="font-size:12px;">
            カテゴリ登録後にアイコンの設定が可能になります。<Br />
            アイコンのサイズは特に指定はありませんが、<span style="color:red"
              >どのアイコンも横と縦の比率は統一</span
            >してください。<Br />
            カテゴリ内のアイテムの順番は、ドラッグで入れ替え可能です。違うカテゴリ間での移動はできません。
            カテゴリの順番は下部にある「カテゴリ並び替え」ボタンから行ってください。
          </p>

          <table class="map_setting_table">
            <tr
              v-for="(item, category_id) in category"
              v-bind:key="category_id"
            >
              <th width="120" style="position:relative;">
                <!-- <img
                    v-if="item.img != ''"
                    :src="imgLoad(item.img)"
                    width="30"
                    height="30"
                    style="vertical-align:middle;cursor: pointer;"
                  /> -->
                <div style="position:absolute; top:4px ;left:4px; color:#777;">
                  {{ category_id }}
                </div>
                <div
                  @click="editIconDialog(category_id, category[category_id])"
                  style="position:absolute;top: 20px;bottom:0;width:100%;padding-top:12px;"
                >
                  {{ item.name }}
                </div>
              </th>
              <td class="pa-1">
                <draggable v-model="item.icons" :group="'items' + category_id">
                  <div
                    v-for="(icon_id, index) in item.icons"
                    v-bind:key="index"
                    style="position:relative;border:1px solid #ccc;padding: 2px;text-align:center;min-width:70px;display:inline-block;vertical-align:middle;margin:2px;"
                    @click="editIconDialog(icon_id, icons[icon_id])"
                  >
                    <div
                      style="position:absolute; top:1px ;left:2px; color:#777;"
                    >
                      {{ icon_id }}
                    </div>
                    <img
                      :src="imgLoad(icons[icon_id].img)"
                      width="30"
                      height="30"
                      style="vertical-align:middle"
                    />
                    <div style="font-size:11px;">{{ icons[icon_id].name }}</div>
                  </div>
                  <v-btn
                    @click="openIconDialog('icon', category_id)"
                    style="border:1px solid #ccc;padding: 2px 10px;min-height:54px; box-shadow:none;margin:4px;"
                    >＋</v-btn
                  >
                </draggable>
              </td>
            </tr>

            <tr>
              <th width="120">
                <v-btn
                  @click="openIconDialog('category')"
                  style="border:1px solid #aaa;padding: 4px 10px;min-height:36px; box-shadow:none"
                  >＋</v-btn
                >
              </th>
              <td></td>
            </tr>
          </table>

          <v-btn
            class="mt-2"
            @click="openSortCategory()"
            outlined
            color="primary"
            >カテゴリ並び替え</v-btn
          >
        </v-card>
      </v-col>

      <v-col cols="5">
        <v-card class="ml-2 pa-2 mr-0">
          <v-row>
            <v-col cols="6">クリック座標【 {{ lat }},{{ lng }} 】</v-col>
            <v-col cols="6">
              <v-switch
                v-model="show_label"
                :label="`ラベル表示(確認用)`"
                dense
                class="ma-0"
                hide-details="true"
              ></v-switch
            ></v-col>
          </v-row>
          <span class="dev_label honban">マスターデータ</span>
          <div style="text-align:center;margin:10px auto;">
            <l-map
              id="map"
              ref="map"
              :crs="crs"
              :min-zoom="-3"
              :max-zoom="5"
              tap="false"
              :bounds="bounds"
              :max-bounds="bounds"
              style="width:100%;height:540px;max-width:100%"
            >
              <l-image-overlay :url="imgLoad(main_img)" :bounds="bounds" />
              <!-- Use default icon -->

              <div v-for="(icon, key) in icons" v-bind:key="key">
                <l-marker
                  v-for="(mark, index) in markers[key]"
                  :key="index"
                  :lat-lng="mark"
                  :visible="mark.visible"
                  :ref="'mark_' + key + '_' + index"
                >
                  <l-icon
                    :class="'test_' + mark.img"
                    :icon-size="[iconSize, iconSize]"
                    :icon-anchor="dynamicAnchor(icons[mark.img_no].pos)"
                    :icon-url="imgLoad(icons[mark.img_no].img)"
                  >
                    <div style="position: relative;">
                      <img
                        :src="imgLoad(icons[mark.img_no].img)"
                        :width="iconSize"
                      />
                      <span class="map_label" :style="checkWidth(mark.label)" v-html="mark.label"></span>
                    </div>
                  </l-icon>

                  <l-popup :options="{ keepInView: true }">
                    <div v-html="mark.content"></div>
                    <v-btn @click="deleteMark(mark)" class="delete_mark" dense
                      >削除</v-btn
                    >
                    <v-btn @click="editMark(mark)" class="edit_mark" dense
                      >編集</v-btn
                    >
                  </l-popup>
                </l-marker>
              </div>
            </l-map>
          </div>

          <p style="font-size:14px; margin:26px 4px 1px 4px;">
            ※マップ保存後に更新内容が反映されない場合は、下記入力欄に使用している記事URL(admin無し)を入れて「キャッシュ削除」のボタンを押してください。
          </p>

          <table style="width:100%">
            <tr>
              <td>
                <v-text-field
                  v-model="cache_url"
                  label="記事URL"
                ></v-text-field>
              </td>
              <td width="120" class="pa-2">
                <v-btn
                  @click="cachePurge()"
                  color="red"
                  outlined
                  style="color: #fff"
                  >キャッシュ削除</v-btn
                >
              </td>
            </tr>
          </table>

          <!-- <div id="map" style="width:690px;height:460px"></div> -->

          <!-- マーク生成 -->
          <v-dialog v-model="dialog" max-width="1200" class="input_form">
            <v-card>
              <v-card-title>
                <div>マーク追加</div>
              </v-card-title>
              <v-card-text>
                <div class="flex_table">
                  <table
                    v-for="(cate, category_id) in category"
                    v-bind:key="category_id"
                    class="ma-0 map_setting_table"
                  >
                    <tr>
                      <th>{{ cate.name }}</th>
                    </tr>
                    <tr>
                      <td class="pa-0">
                        <v-radio-group
                          v-model="icon_select_no"
                          row
                          dense
                          class="ma-0"
                          hide-details="true"
                        >
                          <v-radio
                            v-for="icon_id in cate.icons"
                            v-bind:key="icon_id"
                            :value="icon_id"
                            :label="icons[icon_id].name"
                            class="map_custom"
                          >
                            <template slot="label">
                              <div class="text-center">
                                <img
                                  :src="imgLoad(icons[icon_id].img)"
                                  width="30"
                                  height="30"
                                />
                                <div style="font-size: 12px;">
                                  {{ icons[icon_id].name }}
                                </div>
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </td>
                    </tr>
                    <!-- -->
                  </table>
                </div>
                <!-- 
                  <v-btn-toggle v-model="icon_select_no" class="ml-1" Mandatory>
                    <v-btn
                      v-for="(item, index) in icons"
                      v-bind:key="index"
                      :value="index"
                    >
                      <img :src="imgLoad(item.img)" width="30" height="30" />
                    </v-btn>
                  </v-btn-toggle> -->

                <v-row>
                  <v-col cols="6">
                    <div class="pa-2 mt">ラベル(任意)</div>
                    <v-text-field
                      outlined
                      ref="label_ref"
                      :value="label"
                      class="ma-1"
                      dense
                      hide-details="true"
                      single-line
                      placeholder="ラベル表示時のテキスト"
                    ></v-text-field
                  ></v-col>
                  <v-col cols="6">
                    <div class="pa-2 mt">
                      検索グループ名(任意) 空の場合はラベルを参照
                      
                    </div>
                    <v-text-field
                      outlined
                      ref="search_group_ref"
                      :value="search_group"
                      class="ma-1"
                      hide-details="true"
                      dense
                      single-line
                      placeholder="検索時のグループ名"
                    ></v-text-field
                  >
                  <div class="pa-2 mt">検索グループ名に表示させたくないときは「<span style="color:red">非表示</span>」と入力</div>
                </v-col>
                </v-row>

                <div class="pa-2">内容(html記述可能)</div>
                <v-textarea
                  outlined
                  ref="content_ref"
                  :value="content"
                  class="ma-1"
                  dense
                  hide-details="true"
                  placeholder="何も入力しない場合は、設定したマークの名称が表示されます。"
                ></v-textarea>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div v-if="sub_flg != true">
                  <v-btn
                    @click="addMark"
                    :disabled="btn_disable_flg"
                    class="mr-3"
                    >保存</v-btn
                  >
                  <v-btn @click="dialog = false" :disabled="btn_disable_flg"
                    >閉じる</v-btn
                  >
                </div>
                <div v-else class="ml-4 red--text">
                  分割編集のデータがある場合は、親マップでマーキングできません。
                </div>
                <!-- <v-btn @click="confirm">確認</v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <link
            rel="stylesheet"
            href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
            integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=="
            crossorigin=""
          />
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="mr-2 pa-2">
          <v-card-title class="custom_title">データ一時保存</v-card-title>

          <v-btn @click="save" color="primary">マップデータ保存</v-btn>

          <div class="pa-2" style="font-size:12px;color:#333;">
            データ保存だけでは本番に反映されません
          </div>
        </v-card>

        <v-card class="mr-2 pa-2 mt-2">
          <v-card-title class="custom_title">本番反映</v-card-title>

          <div
            v-if="save_flg"
            style="color:red;padding:10px 0;font-weight:bold;font-size:12px;"
          >
            ※未保存のデータがあります。
          </div>

          <v-btn
            @click="upload"
            color="red"
            style="color:#fff;min-width:154px;"
            :disabled="save_flg"
            >本番反映</v-btn
          >
          <div class="pa-2" style="font-size:12px;">
            本番反映後はキャッシュ削除を忘れずに
          </div>
        </v-card>

        <v-card class="mr-2 mt-2 pa-2">

          <v-card-title class="custom_title">スラッグ(任意)
            <v-btn @click="mapGroupPage()" class="back_button" v-if="slug != ''">
              <v-icon color="blue darken-2"> mdi-arrow-right </v-icon>検索グループ設定
            </v-btn>

          </v-card-title>
          <v-text-field
            v-model="slug"
            hide-details="true"
            class="pt-2"
            label=" 例： monst"
            outlined
            dense
          ></v-text-field>
          <span style="font-size:10px;">検索グループに画像を設定する際に利用します。</span>

          <v-card-title class="custom_title"
            >設定一覧
            <v-btn @click="mapPositionPage()" class="back_button">
              <v-icon color="blue darken-2"> mdi-arrow-right </v-icon>設定詳細
            </v-btn></v-card-title
          >

          <table
            v-for="(cate, category_id) in category"
            v-bind:key="category_id"
            class="ma-0 map_setting_table"
          >
            <tr>
              <th width="110">
                <!-- <img
                    v-if="cate.img != ''"
                    :src="imgLoad(cate.img)"
                    width="20"
                    height="20"
                    style="vertical-align:middle"
                  /> -->

                {{ cate.name }}
              </th>
            </tr>
            <tr
              v-for="icon_id in cate.icons"
              v-bind:key="icon_id"
              :value="icon_id"
              :label="icons[icon_id].name"
            >
              <td class="pa-0">
                <div
                  v-for="(item, index) in markers[icon_id]"
                  v-bind:key="item.id"
                  @click="showPopup(item, index)"
                >
                  <v-row dense class="justify-center align-center text-center">
                    <v-col cols="2">
                      <img
                        :src="showIcon(item.img_no)"
                        width="30"
                        height="30"
                      />
                    </v-col>
                    <v-col cols="10" class="text-left"
                      >{{ item.content || icons[icon_id].name }}

                      <span
                        style="display:block; font-size:90%; color: #999;"
                        >{{ item.id }}</span
                      >
                    </v-col>
                  </v-row>
                </div>
              </td>
            </tr>

            <!-- -->
          </table>



          <!-- <table class="preview_table">
              <tr
                v-for="(item, index) in markers"
                v-bind:key="item.id"
                @click="showPopup(index)"
              >
                <td width="60">
                  <img :src="showIcon(item.img_no)" width="30" />
                </td>
                <td>{{ item.content }}</td>
              </tr>
            </table> -->
        </v-card>
        <!-- {{ icons }}
            {{ markers }} -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";

import L from "leaflet";
import { LMap, LImageOverlay, LMarker, LPopup, LIcon } from "vue2-leaflet";

export default {
  name: "MapGenerate",
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    LIcon,
    draggable,
  },
  data() {
    return {
      //多重クリック制御
      btn_disable_flg: true,

      //データベースの向き先
      target_env: "",

      //キャッシュURL
      cache_url: "",

      //ラベルの表示フラグ
      show_label: true,

      //カテゴリソートダイアログ
      category_sort_dialog: false,
      sort_category: [],

      //ローディング
      absolute: true,
      opacity: 0.6,
      overlay: true,

      //未保存判定フラグ
      save_flg: false,
      prev_icons: {},
      prev_category: {},
      prev_markers: {},

      //マップ設定
      crs: L.CRS.Simple,
      iconSize: 24,
      dialog: false,
      icon_dialog: false,

      editIcon: { id: "", name: "", img: "", type: "" },
      defaultItem: { id: "", name: "", img: "",pos: "5", type: "" },
      // icon_title: "",
      // icon_path: "",

      bounds: [
        [0, 0],
        [0, 0],
      ],

      markers: {}, //設定したマークデータ
      //保存データ
      saveData: {
        id: -1,
        name: "",
        content: "",
      },

      sub_flg: false,

      icons: {}, //マップ上のアイコン
      category: {
        // c1: { name: "aaaaa" },
        // c2: { name: "aaaaa" },
      }, //アイコンカテゴリ

      //マーク関連
      icon_select_no: "i1", //アイコン選択番号
      before_icon_no: "i1",
      mark_select_id: -1,
      editMarkMode: false,
      lat: 0,
      lng: 0,
      myMap: null,
      GreenIcon: "",

      label: "",
      search_group: "",
      content: "",
      styleObject: {
        top: "0px",
        left: "0px",
      },
      slug: "",
      main_img: "",
      main_img_height: 500,
      main_img_width: 500,
    };
  },

  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });

    console.log(`${this.$route.params.id}`);
    var self = this;

    if (this.$route.params.id == "new") {
      self.overlay = false;
      self.initMap();
      return;
    }

    axios
      .get(process.env.VUE_APP_MAP_DETAIL, {
        params: { id: this.$route.params.id },
      })
      .then(function(response) {
        var item = response.data;
        var content = JSON.parse(item.content);

        self.sub_flg = item.sub_flg || false;

        if (self.$route.params.copy) {
          self.category = Object.assign({}, content.category);
          self.prev_category = Object.assign({}, content.category);

          self.icons = Object.assign({}, content.icons);
          self.prev_icons = Object.assign({}, content.icons);
        } else {
          self.saveData.id = item.id;
          self.saveData.name = item.name;
          

          self.main_img = content.main_img;
          self.slug = content.slug;

          self.category = Object.assign({}, content.category);
          self.prev_category = Object.assign({}, content.category);

          self.icons = Object.assign({}, content.icons);
          self.prev_icons = Object.assign({}, content.icons);

          self.markers = Object.assign({}, content.markers);
          self.prev_markers = Object.assign(
            {},
            JSON.parse(JSON.stringify(content.markers))
          );
        }

        self.initMap();
      })
      .finally(function() {
        self.overlay = false;
      });
  },

  created() {
    this.target_env = process.env.VUE_APP_MAP_DETAIL;
    if (this.target_env.indexOf("tool-test") > -1) {
      this.target_env = "テスト環境";
    } else {
      this.target_env = "本番環境";
    }
  },

  // mounted() {},

  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize];
    },

  },

  watch: {
    main_img(val) {
      var image = new Image();
      var self = this;
      image.onload = function() {
        self.main_img_width = image.width;
        self.main_img_height = image.height;

        self.bounds = [
          [0, 0],
          [image.height / 2, image.width / 2],
        ];

        self.initMapSetting();
      };
      image.src = this.imgLoad(val);
    },
  },

  methods: {

    dynamicAnchor(pos) {
      if(pos == 1){
        return [0, 0];
      }
      else if(pos == 2){
        return [this.iconSize / 2, 0];
      }
      else if(pos == 3){
        return [this.iconSize , 0];
      }
      else if(pos == 4){
        return [0, this.iconSize / 2];
      }
      else if(pos == 5){
        return [this.iconSize / 2, this.iconSize / 2];
      }
      else if(pos == 6){
        return [this.iconSize, this.iconSize / 2];
      }
      else if(pos == 7){
        return [0, this.iconSize];
      }
      else if(pos == 8){
        return [this.iconSize / 2, this.iconSize];
      }
      else if(pos == 9){
        return [this.iconSize, this.iconSize];
      }
      return [this.iconSize / 2, this.iconSize / 2];
    },


    checkTextLength(str) {
    const substrings = str.split(','); // カンマ区切りで分割
    let maxLen = 0; // 最も長い文字列の長さを保持

    // 各部分文字列の長さを計算し、最も長いものを探す
    for (let j = 0; j < substrings.length; j++) {
      // const len = calculateLength(substrings[i]);
      let len = 0;
      for (let i = 0; i < substrings[j].length; i++) {
        if (substrings[j][i] === "." || substrings[j][i] === "(" || substrings[j][i] === ")") {
          // 何もしない
        } else if (substrings[j][i].match(/[ -~]/)) { // 半角文字
          len += 4;
        } else { // 全角文字
          len += 12;
        }
      }

      if (len > maxLen) {
        maxLen = len;
      }
    }

    if(maxLen < 28){
      maxLen = 28;
    }

    return maxLen;
  },

    checkWidth(text = 0) {
      if (text == 0 || this.show_label == false) {
        return "display:none;";
      }

      var width = this.checkTextLength(text);
      var left = this.checkTextLength(text) / 2 - 10;

      return "left: -" + left + "px;width:" + width + "px;";
    },

    openSortCategory() {
      this.category_sort_dialog = true;
      this.sort_category = [];

      console.log(this.sort_category);

      for (var key in this.category) {
        var element = this.category[key];
        var item = {
          id: key,
          name: element.name,
        };
        this.sort_category.push(item);
      }
    },

    saveSortCategory() {
      var tmp = {};
      this.sort_category.forEach((element) => {
        tmp[element.id] = this.category[element.id];
      });
      this.category = tmp;
      self.prev_category = Object.assign({}, self.category);
      this.checkSave();

      this.category_sort_dialog = false;
    },

    backPage() {
      if (this.save_flg) {
        if (
          !window.confirm(
            "未保存のデータがあります。\n保存せずに一覧に戻りますか？"
          )
        ) {
          //何もしない
          return;
        }
      }

      this.$router.push({
        name: "mapGenerate",
      });
    },

    //マップの初期化
    initMap() {
      this.myMap = this.$refs.map.mapObject;

      // this.myMap.setView([0,0]);

      //クリックイベント
      var self = this;
      this.myMap.on("click", function(e) {
        //クリック位置経緯度取
        self.lat = e.latlng.lat.toFixed(0);
        self.lng = e.latlng.lng.toFixed(0);
        self.content = "";
        self.label = "";
        self.search_group = "";
        
        if (Object.keys(self.icons).length == 0) {
          alert("アイコンを設定してください");
          return;
        }
        self.btn_disable_flg = false;

        self.dialog = true;
        self.editMarkMode = false;
      });
    },

    initMapSetting() {
      // alert("設定変更")
      // this.myMap = this.$refs.map.mapObject;
      // var tmp = L.LatLngBounds([0, 0], [this.main_img_height/2, this.main_img_width/2])
      // this.myMap.setMaxBounds(
      //   tmp
      // ); //表示可能範囲
      // this.myMap.fitBounds(tmp);
      //   this.myMap.setBounds(
      //   new L.LatLngBounds([0,0],[this.main_img_height/2, this.main_img_width/2])
      // ); //表示可能範囲
      //   this.myMap.setMaxBounds(
      //   new L.LatLngBounds([0,0],[this.main_img_height/2, this.main_img_width/2])
      // ); //表示可能範囲
      // this.initMapSetting()
      // this.myMap.fitBounds([0,0],[this.main_img_height/2, this.main_img_width/2]);
      // this.myMap.setView([0,0],2);
    },

    //アイコン表示
    showIcon(index) {
      return this.imgLoad(this.icons[index]["img"]);
    },

    //キャッシュ削除
    cachePurge() {
      // cache_url
      this.cache_url = this.cache_url.replace("admin.", "");
      axios
        .get(process.env.VUE_APP_MAP_CACHE, {
          params: { url: this.cache_url },
        })
        .then(function(response) {
          console.log(response);
          alert("キャッシュを削除しました。");
        });
    },

    //CSV本番反映
    upload() {
      var self = this;
      self.overlay = true;
      if (window.confirm("マップデータを本番に反映しますか？")) {
        axios
          .post(process.env.VUE_APP_MAP_UPLOAD, {
            data: self.saveData,
          })
          .then(function(response) {
            console.log(response);
            alert(
              "CSVアップロードしました。\nすでに本番記事に導入している場合はキャッシュの削除も行ってください"
            );
            window.location.reload();
          })
          .finally(function() {
            self.overlay = false;
          });
      } else {
        self.overlay = false;
      }
    },

    //マップデータの保存
    save() {
      var self = this;

      if (self.saveData.name == "") {
        alert("保存名を入力してください");
        return;
      }

      self.overlay = true;
      // self.saveData.name = "test"
      self.saveData.content = {};
      self.saveData.content.main_img = this.filterURL(this.main_img);
      self.saveData.content.slug = this.slug;
      self.saveData.content.category = this.category;

      // self.saveData.content.icons = this.icons;
      self.saveData.content.icons = {};
      for (var key in this.category) {
        var element = this.category[key];
        element.icons.forEach((val) => {
          self.saveData.content.icons[val] = this.icons[val];
        });
      }
      // console.log(this.markers);

      self.saveData.content.markers = this.markers;
      self.saveData.content.main_img_width = this.main_img_width;
      self.saveData.content.main_img_height = this.main_img_height;

      //
      axios
        .post(process.env.VUE_APP_MAP_UPDATE, {
          data: self.saveData,
        })
        .then(function(response) {
          console.log(response);
          //新規追加
          if (
            response.data["status"] == 0 ||
            response.data["status"] == 1 ||
            response.data["status"] == 2
          ) {
            self.saveData.id = response.data["last_id"];
            if (response.data["status"] === false) {
              alert("データの保存に失敗しました。");
            } else {
              alert("データを保存しました。");
            }
            self.prev_icons = Object.assign(
              {},
              JSON.parse(JSON.stringify(self.icons))
            );
            self.prev_markers = Object.assign(
              {},
              JSON.parse(JSON.stringify(self.markers))
            );
            self.prev_category = Object.assign(
              {},
              JSON.parse(JSON.stringify(self.category))
            );

            self.checkSave();
          } else {
            if (response.data == "ERROR_SAME_NAME") {
              alert("同じ保存名が存在しています。");
            } else {
              alert("更新失敗しました！");
            }
          }
        })
        .finally(function() {
          self.overlay = false;
        });
    },

    imgLoad(url) {
      url = this.filterURL(url);

      if (url != "") {
        return "https://appmedia.jp" + url;
      }
      return "";
    },

    filterURL(url) {
      url = url.replace("https://appmedia.jp", "");
      url = url.replace("https://admin.appmedia.jp", "");
      return url;
    },

    //未保存チェック
    checkSave() {
      if (
        JSON.stringify(this.icons) == JSON.stringify(this.prev_icons) &&
        JSON.stringify(this.markers) == JSON.stringify(this.prev_markers) &&
        JSON.stringify(this.category) == JSON.stringify(this.prev_category)
      ) {
        this.save_flg = false;
      } else {
        this.save_flg = true;
      }
    },

    /* ----------------
        アイコン追加処理
      ---------------- */
    openIconDialog(type, cate_id = 0) {
      this.btn_disable_flg = false;
      this.icon_dialog = true;
      this.editIcon = Object.assign({}, this.defaultItem);
      this.editIcon.type = type;
      this.editIcon.category = cate_id;
    },

    editIconDialog(index, item) {
      this.btn_disable_flg = false;

      if(!item.pos){
        item.pos = 5;
      }

      this.editIcon = Object.assign({}, item);
      this.icon_dialog = true;
      this.editIcon.id = index;
      this.editIcon.name = item.name;
      this.editIcon.img = item.img;
      this.editIcon.pos = item.pos;
      this.editIcon.category = item.category;
    },

    //アイコンの削除（使っているマークも消す)
    deleteIcon() {
      if (window.confirm("設定しているマークも削除されます。")) {
        //タイプによって処理を変える
        // categoryのときthis.editIcon.idはカテゴリID
        // iconのときthis.editIcon.idはアイコンID
        // になるので注意

        if (this.editIcon.type == "category") {
          const category_id = this.editIcon.id;
          this.category[category_id].icons.forEach((element) => {
            delete this.markers[element];
            delete this.icons[element];
          });
          delete this.category[category_id];
        } else {
          const category_id = this.icons[this.editIcon.id].category;
          const icon_id = this.editIcon.id;

          const index = this.category[category_id].icons.indexOf(icon_id);
          this.category[category_id].icons.splice(index, 1);
          delete this.markers[icon_id];
          delete this.icons[icon_id];
        }
      }

      this.icon_dialog = false;
    },
    /* ----------------
        カテゴリ・アイコン処理
      ---------------- */

    addCategory() {
      if (this.editIcon.name == "") {
        alert("名前や画像パスを入力してください");
        return;
      }
      this.editIcon.img = this.filterURL(this.editIcon.img);
      //編集
      if (this.editIcon.id != "") {
        this.category[this.editIcon.id] = this.editIcon;
      }
      //追加
      else {
        var max_category_id = this.checkCategoryMaxId();
        this.editIcon.id = "c" + max_category_id;
        this.category["c" + max_category_id] = Object.assign({}, this.editIcon);
        this.category["c" + max_category_id].icons = [];
        // this.markers["c" + max_id] = [];
      }

      this.checkSave();

      this.icon_dialog = false;
    },

    addIcon() {
      if (this.editIcon.name == "" || this.editIcon.img == "") {
        alert("名前や画像パスを入力してください");
        return;
      }

      this.btn_disable_flg = true;

      this.editIcon.img = this.filterURL(this.editIcon.img);
      //編集
      if (this.editIcon.id != "") {
        this.icons[this.editIcon.id] = this.editIcon;
      }
      //追加
      else {
        var max_icon_id = this.checkIconMaxId();
        this.icons["i" + max_icon_id] = Object.assign({}, this.editIcon);
        this.markers["i" + max_icon_id] = [];

        //カテゴリにアイコンIDを紐付け

        console.log(
          this.editIcon.category,
          this.category[this.editIcon.category]
        );
        this.category[this.editIcon.category].icons.push("i" + max_icon_id);
      }

      this.checkSave();

      this.icon_dialog = false;
    },

    checkIconMaxId() {
      var max = 0;

      Object.keys(this.icons).forEach(function(index) {
        var tmp = index.replace("i", "");

        var no = parseInt(tmp, 10);
        if (no > max) {
          max = no;
        }
      });

      return max + 1;
    },
    checkCategoryMaxId() {
      var max = 0;

      Object.keys(this.category).forEach(function(index) {
        var tmp = index.replace("c", "");

        var no = parseInt(tmp, 10);
        if (no > max) {
          max = no;
        }
      });

      return max + 1;
    },
    /* ----------------
        マーク処理
      ---------------- */
    addMark() {
      // console.log(this.$refs.content_ref.$data.lazyValue);

      //v-modelを通すと毎回mapに描写が入るためrefで一旦回避
      this.content = this.$refs.content_ref.$data.lazyValue;
      this.label = this.$refs.label_ref.$data.lazyValue;

      this.search_group = this.$refs.search_group_ref.$data.lazyValue;

      //多重クリック制御
      this.btn_disable_flg = true;

      // Dateオブジェクトを作成
      var date = new Date();

      // UNIXタイムスタンプを取得する (ミリ秒単位)
      var a = date.getTime();

      // UNIXタイムスタンプを取得する (秒単位 - PHPのtime()と同じ)
      var b = Math.floor(a / 1000);
      var id = b.toString(32);

      //登録用のオブジェクト生成
      var item = {
        id: id,
        label: this.label,
        search_group: this.search_group,
        content: this.content,
        lng: this.lng,
        lat: this.lat,
        img_no: this.icon_select_no,
        visible: true,
      };

      // console.log("before_icon_no",this.before_icon_no , this.icon_select_no);
      // console.log(item);

      if (this.editMarkMode) {
        var self = this;

        //before_icon_no

        //icon_select_no

        var target_index = this.markers[this.before_icon_no].filter(function(
          element
        ) {
          if (element.id == self.mark_select_id) {
            return true;
          } else {
            return false;
          }
        });

        //編集前データを取得
        const index = this.markers[this.before_icon_no].indexOf(
          target_index[0]
        );
        const before_item = Object.assign(
          {},
          this.markers[this.before_icon_no][index]
        );

        before_item.img_no = this.icon_select_no;
        before_item.content = this.content;
        before_item.label = this.label;
        before_item.search_group = this.search_group;

        // console.log("1",before_item);
        // console.log("2",item);

        if (this.before_icon_no != this.icon_select_no) {
          this.markers[this.before_icon_no].splice(index, 1);
          this.markers[this.icon_select_no].push(before_item);
        } else {
          this.markers[this.icon_select_no][index].content = this.content;
          this.markers[this.icon_select_no][index].label = this.label;
          this.markers[this.icon_select_no][
            index
          ].search_group = this.search_group;

          this.markers[this.icon_select_no][index].img_no = this.icon_select_no;
        }

        // if(target_index.length == 0){
        //   this.markers[this.icon_select_no].push(item);
        // }else{
        //   const index = this.markers[this.icon_select_no].indexOf(target_index[0]);
        //   this.markers[this.icon_select_no][index].content = this.content;
        //   this.markers[this.icon_select_no][index].img_no = this.icon_select_no;
        // }
      } else {
        if (this.markers[this.icon_select_no] == null) {
          this.markers[this.icon_select_no] = [];
        }

        this.markers[this.icon_select_no].push(item);
      }

      // this.saveData.push(item);
      this.dialog = false;
      this.mark_select_id = -1;
      this.editMarkMode = false;
      this.checkSave();
    },
    deleteMark(item) {
      if (window.confirm("該当マークを削除します")) {
        console.log("delete", item);
        const index = this.markers[item.img_no].indexOf(item);
        this.markers[item.img_no].splice(index, 1);

        this.myMap.closePopup();

        this.checkSave();

        //連想配列の階層が深い場合、描写されないので意図的に処理を走らせる
        this.$set(this.markers);
      }
    },
    editMark(item) {
      console.log(item);
      this.btn_disable_flg = false;
      this.mark_select_id = item.id;
      this.icon_select_no = item.img_no;
      this.before_icon_no = item.img_no;
      this.content = item.content;
      this.label = item.label;
      this.search_group = item.search_group || "";
      this.editMarkMode = true;
      this.dialog = true;
    },

    //ポップアップの動的表示
    showPopup(item, index) {
      var object = "mark_" + item.img_no + "_" + index;
      this.$refs[object][0].mapObject.openPopup();
    },

    //マップの設定一覧へ遷移
    mapPositionPage() {
      let resolvedRoute = this.$router.resolve({
        name: "mapPositionDetail",
        params: { parent_id: this.$route.params.id },
      });
      window.open(resolvedRoute.href, "_blank");
    },

    //マップの設定一覧へ遷移
    mapGroupPage() {

      let resolvedRoute = this.$router.resolve({
        name: "mapGroupDetail",
        params: { slug: this.slug},
      });
      window.open(resolvedRoute.href, "_blank");
    },

    //マップグループの設定一覧へ遷移
    mapGroupSettingPage() {
      let resolvedRoute = this.$router.resolve({
        name: "mapPositionDetail",
        params: { parent_id: this.$route.params.id },
      });
      window.open(resolvedRoute.href, "_blank");
    },


  },
};
</script>
<style>
.map_custom {
  margin: 2px !important;
  min-width: 60px;
  text-align: center;
}
.map_custom > div {
  display: none;
}
.map_custom .v-label {
  display: inline-block !important;
}

.map_generate .custom_title {
  padding: 0px;
  font-size: 15px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  margin: 10px 6px 7px 6px;
  color: #148318;
}
.back_button {
  border: none !important;
  box-shadow: none !important;
  background: #fff !important;
  color: #1976d2 !important;
}

.preview_table {
  width: 100%;
}
.preview_table td {
  border-bottom: 1px dashed #ccc !important;
}

.map_setting_table {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}
.map_setting_table td,
.map_setting_table th {
  border: 1px solid #ddd;
  padding: 4px;
  font-size: 12px;
}
.map_setting_table th {
  background: #dae1f3;
}

.flex_table {
  display: flex;
  flex-wrap: wrap;
}
.flex_table .map_setting_table {
  width: auto;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group)
  .v-btn.v-btn.v-item--active {
  border: 2px solid orange !important;
  background: #fff9c6;
}
.input_form {
  z-index: 9999999999;
}
#map {
  cursor: crosshair;
}
#pointer2 {
  position: absolute;
  color: #dcf551;
  font-size: 10px;
  z-index: 99999999;
  text-shadow: 0px 0px 5px #fff;
}

.delete_mark {
  font-size: 12px;
  padding: 0 !important;
  height: 24px !important;
  color: white !important;
  font-weight: bold;
  background: red !important;
}
.edit_mark {
  font-size: 12px;
  padding: 0 !important;
  height: 24px !important;
  color: white !important;
  font-weight: bold;
  background: rgb(51, 66, 197) !important;
}

.leaflet-popup-content {
  widows: 100px !important;
}

.v-radio {
  margin: 2px;
  padding: 6px;
  border: 1px solid #eee !important;
  border-radius: 4px;
}

.v-item--active {
  border: 2px solid #ff9800 !important;
  background: #ffeed4;
}

.map_label {
  border-radius: 4px;
  padding: 1px 4px;
  display: block;
  background: #302d21c9;
  color: #fff;
  text-align: center;
  font-size: 10px;
  position: absolute;
  left: calc(-50% + 12px);
  word-break: break-all;
}
.dev_label {
  display: block;
  width: 140px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  border-radius: 24px;
}
.dev_label.honban {
  background: #4caf50;
}

.position_check {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
}
.position_check span {
  position: absolute;
  background: red;
  color: yellow;
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 20px;
}

.position_check span.select{
  background: green;
}

.position_check .p1 {
  top: -7px;
  left: -6px;
}
.position_check .p2 {
  top: -7px;
  left: 13px;
}
.position_check .p3 {
  top: -7px;
  left: 32px;
}
.position_check .p4 {
  top: 12px;
  left: -6px;
}
.position_check .p5 {
  top: 12px;
  left: 13px;
}
.position_check .p6 {
  top: 12px;
  left: 32px;
}
.position_check .p7 {
  top: 32px;
  left: -6px;
}
.position_check .p8 {
  top: 32px;
  left: 13px;
}
.position_check .p9 {
  top: 32px;
  left: 32px;
}
</style>
